import React from "react";
import { useTranslation } from "@helpers/translate";
import { PairsList } from "./PairsList";
import { ReactComponent as CloseIcon } from "@assets/images/icons/close-dropdown.svg";
import { ReactComponent as SearchIcon } from "@assets/images/icons/input-search.svg";

/**
 * Asset selection modal: header, search and pairs list.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {object[]} props.pairs
 * @param {boolean} props.loading
 * @param {string} props.search
 * @param {(value: string) => void} props.onSearch
 * @param {(pair: object) => void} props.onSelect
 * @param {() => void} props.onClose
 * @param {(slug: string) => boolean} props.isFavorite
 * @param {(pair: object) => void} props.onToggleFavorite
 */
export const PairsModal = ({
  isOpen,
  pairs,
  loading,
  search,
  onSearch,
  onSelect,
  onClose,
  isFavorite,
  onToggleFavorite,
}) => {
  const { __ } = useTranslation();

  return (
    <div className={`futures-pairs${isOpen ? " futures-pairs--open" : ""}`}>
      <div
        onClick={onClose}
        className="futures-pairs__backdrop"
        data-futures-guide="asset-selection-backdrop"
      />

      <div
        className="futures-pairs__modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="futures-pairs-title"
        data-futures-guide="available-assets"
      >
        <div className="futures-pairs__header">
          <h3 id="futures-pairs-title" className="futures-pairs__title">
            {__("common.asset_selection")}
          </h3>
          <button
            type="button"
            className="futures-pairs__close"
            aria-label="Close"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>

        <label className="futures-pairs__search">
          <SearchIcon className="futures-pairs__search-icon" aria-hidden="true" />
          <input
            value={search}
            type="text"
            className="futures-pairs__search-input"
            placeholder={__("common.search_crypto")}
            onChange={(event) => onSearch(event.target.value)}
          />
        </label>

        <PairsList
          pairs={pairs}
          loading={loading}
          onSelect={onSelect}
          isFavorite={isFavorite}
          onToggleFavorite={onToggleFavorite}
        />
      </div>
    </div>
  );
};
